import React, { useEffect, useLayoutEffect, useState } from "react";
import styles from "./PaymentPlanPage.module.scss";
import PaymentPlanCard from "../../components/PaymentPlanCard/PaymentPlanCard";
import { API } from "service/Interceptor";
import { subscriptionPlan } from "service/apiUrl";
import toast from "components/Toast/toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PaymentCardSkeleton from "./PaymentPlanSkeleton";
import { format } from "date-fns";
import GreenTickSVG from "components/SVGComponents/GreenTickSVG";
import { getActivePlanOfUser } from "reducer/paymentSlice";
import Modal from "components/Modal/Modal";

const PaymentPlanPage = () => {
  const { userProfile } = useSelector((state) => state.userProfile);
  const { activePlan } = useSelector((state) => state.payment);

  const [paymentCards, setPaymentCards] = useState([]);
  // const [showGreenTick, setShowGreenTick] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const [freeTrialModal, setFreeTrialModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const endDate =
    format(new Date(activePlan?.endDate ?? null), "MMM dd, yyyy") || "N/A";
  const startDate =
    format(new Date(activePlan?.startDate ?? null), "MMM dd, yyyy") || "N/A";

  // console.log(userProfile);
  // console.log(activePlan);

  const handleModalClose = () => {
    setTimeLeft(0);
    navigate("/projects?compose=1");
  };

  useLayoutEffect(() => {
    if (userProfile?.userType === "CREATOR") {
      navigate("/feed");
    }
  }, []);

  useEffect(() => {
    const getSubscrptionPlan = async () => {
      setIsLoading(true);
      try {
        const res = await API.get(subscriptionPlan);
        if (res?.data?.success === true) {
          const sortedInAscending = res?.data?.data.sort(
            (a, b) => a.amount - b.amount
          );
          setPaymentCards(sortedInAscending);
          setIsLoading(false);
        } else {
          toast.error(res?.data?.message || "Something wrong happened");
        }
      } catch (error) {
        console.log(error);
        toast.error(error?.message || "Something wrong happened");
      }
    };
    getSubscrptionPlan();
  }, []);

  useEffect(() => {
    dispatch(getActivePlanOfUser());

    let timer;
    if (!activePlan?.freeTrial) {
      timer = setInterval(() => {
        setFreeTrialModal(true);
        setTimeLeft((prev) => {
          if (prev <= 1) {
            setFreeTrialModal(false);
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } else {
      return;
    }

    // if (timeLeft === 0) {
    //   handleModalClose();
    // }
    return () => clearInterval(timer);
  }, [timeLeft]);

  return (
    <main className={styles.paymentPlanPage}>
      <section className={styles.container}>
        {activePlan?.freeTrial === true || activePlan?.freeTrial === false ? (
          <div className={styles.freeTrialAlert}>
            {
              <p>
                {activePlan?.freeTrial
                  ? "Your free trial period started on"
                  : `Your ${activePlan?.name} has been started from`}{" "}
                <span>{startDate || "N/A"}</span> and ends on{" "}
                <span>{endDate || "N/A"}</span>.
              </p>
            }
          </div>
        ) : (
          <div className={styles.heading}>
            <p>Start your 15 days free trial today </p>
          </div>
        )}

        <Modal
          modalOpen={freeTrialModal}
          width="35"
          heading=""
          onClose={handleModalClose}
        >
          <div className={styles.greentickSection}>
            <GreenTickSVG width="40" height="40" className={styles.greenTick} />
            <p>Free Trial Activated Successfully</p>
          </div>
        </Modal>

        <div className={styles.cardContainer}>
          {!isLoading ? (
            paymentCards?.map((plan) => {
              return (
                <PaymentPlanCard
                  key={plan?.id}
                  planId={plan?.id}
                  cardname={plan?.name}
                  currPrice={plan?.amount}
                  duration={plan?.planDurationMonth}
                  description={plan?.description}
                  taxPercent={plan?.taxPercentage}
                  taxAmount={plan?.taxAmount}
                  totalAmount={plan?.totalAmount}
                  setTimeLeft={setTimeLeft}
                />
              );
            })
          ) : (
            <div
              style={{
                display: "flex",
                gap: "1.5rem",
              }}
            >
              <PaymentCardSkeleton count={2} />
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default PaymentPlanPage;
